import React from 'react';
import type { SelectionEdge } from './emailBuilderSelectionEdgeStrips';

type SelectionEdgeLevel = 'row' | 'column';

type SelectionEdgeStripsProps = {
  level: SelectionEdgeLevel;
  suppressedEdges?: readonly SelectionEdge[];
  forcedHighlightEdges?: readonly SelectionEdge[];
};

const STRIP_EDGES: readonly SelectionEdge[] = ['start', 'end'];

export function SelectionEdgeStrips({
  level,
  suppressedEdges = [],
  forcedHighlightEdges = [],
}: SelectionEdgeStripsProps) {
  const axis = level === 'row' ? 'horizontal' : 'vertical';
  const suppressed = new Set(suppressedEdges);
  const forcedHighlight = new Set(forcedHighlightEdges);

  return (
    <>
      {STRIP_EDGES.filter(edge => !suppressed.has(edge)).map(edge => (
        <div
          key={edge}
          className="email-builder-selection-edge-strip"
          data-editor-chrome
          data-level={level}
          data-edge={edge}
          data-axis={axis}
          data-forced-highlight={forcedHighlight.has(edge) ? 'true' : undefined}
          aria-hidden
        />
      ))}
    </>
  );
}
